import { render, staticRenderFns } from "./TotalBunkerChart.vue?vue&type=template&id=8b6de2e4&scoped=true"
import script from "./TotalBunkerChart.vue?vue&type=script&lang=js"
export * from "./TotalBunkerChart.vue?vue&type=script&lang=js"
import style0 from "./TotalBunkerChart.vue?vue&type=style&index=0&id=8b6de2e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b6de2e4",
  null
  
)

export default component.exports